import type { ResolvedCommentHandler } from '@confluence/content-types-bridge-comments';
import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';
import type { WithIntlProps, WrappedComponentProps } from 'react-intl';
import type { FocusedCommentData } from '../src/resolvedTypes.ts';

export const ResolvedInlineCommentsDialogLoader: LoadableType<
	WithIntlProps<
		{
			contentId: string;
			context: 'renderer' | 'editor' | 'whiteboard' | 'database' | 'slide';
			focusedCommentData?: FocusedCommentData;
			onClose?: () => void;
			onReopenResolvedCommentHandler?: ResolvedCommentHandler;
		} & WrappedComponentProps
	>
> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ResolvedInlineCommentsDialog" */ '../src/ResolvedInlineCommentsDialog.tsx'
			)
		).ResolvedInlineCommentsDialog,
});
